import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_ADVANCED_FORMS_REQUEST = 'GET_ADVANCED_FORMS_REQUEST';
export const GET_ADVANCED_FORMS_SUCCESS = 'GET_ADVANCED_FORMS_SUCCESS';
export const GET_ADVANCED_FORMS_FAILURE = 'GET_ADVANCED_FORMS_FAILURE';

export const GET_ADVANCED_FORMS_COUNT_REQUEST = 'GET_ADVANCED_FORMS_COUNT_REQUEST';
export const GET_ADVANCED_FORMS_COUNT_SUCCESS = 'GET_ADVANCED_FORMS_COUNT_SUCCESS';
export const GET_ADVANCED_FORMS_COUNT_FAILURE = 'GET_ADVANCED_FORMS_COUNT_FAILURE';

function requestGetAdvancedForms() {
  return {
    type: GET_ADVANCED_FORMS_REQUEST,
    isGettingForms: true
  };
}

function receiveGetAdvancedForms(forms, formsCount, gridTotalLimit) {
  return {
    type: GET_ADVANCED_FORMS_SUCCESS,
    isGettingForms: false,
    forms,
    formsCount,
    gridTotalLimit
  };
}

function rejectGetAdvancedForms() {
  return {
    type: GET_ADVANCED_FORMS_FAILURE,
    isGettingForms: false
  };
}

export function getAdvancedForms(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, clientId, customerName, customerIdentifier, accountNumber, accountName, formTypes) {
  return (dispatch) => {
    dispatch(requestGetAdvancedForms());
    const promise = () => ApiService
      .getAdvancedForms(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, clientId, customerName, customerIdentifier, accountNumber, accountName, formTypes)
      .then((response) => {
        dispatch(receiveGetAdvancedForms(response.data.items, response.data.totalCount, response.data.totalLimit));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetAdvancedForms, true));
        }
      });
    return promise();
  };
}

function requestGetAdvancedFormsCount() {
  return {
    type: GET_ADVANCED_FORMS_COUNT_REQUEST,
    isGettingForms: true
  };
}

function receiveGetAdvancedFormsCount(clientCounts) {
  return {
    type: GET_ADVANCED_FORMS_COUNT_SUCCESS,
    isGettingForms: false,
    clientCounts
  };
}

function rejectGetAdvancedFormsCount() {
  return {
    type: GET_ADVANCED_FORMS_COUNT_FAILURE,
    isGettingForms: false
  };
}

export function getAdvancedFormsCount(clientIds, customerName, customerIdentifier, accountNumber, accountName, formFamilies) {
  return (dispatch) => {
    dispatch(requestGetAdvancedFormsCount());
    const promise = () => ApiService
      .getAdvancedFormsClientCounts(clientIds, customerName, customerIdentifier, accountNumber, accountName, formFamilies)
      .then((response) => {
        dispatch(receiveGetAdvancedFormsCount(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetAdvancedFormsCount, true));
        }
      });
    return promise();
  };
}

export function getAdvancedFormsByObject(requestObject) {
  return getAdvancedForms(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.clientIds,
    requestObject.customerName,
    requestObject.customerIdentifier,
    requestObject.accountNumber,
    requestObject.accountName,
    requestObject.formTypes
  );
}

export function getAdvancedFormsCountByObject(requestObject) {
  return getAdvancedFormsCount(
    requestObject.clientIds,
    requestObject.customerName,
    requestObject.customerIdentifier,
    requestObject.accountNumber,
    requestObject.accountName,
    requestObject.formTypes
  );
}
